import { Injectable } from '@angular/core';
import { Config } from '../../../infrastructure/config';
import { LocalstorageService } from '../localstorage/localstorage.service';
import { Router } from '@angular/router';
import { UserInfoService } from 'src/services/request/user/userinfo.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private localStorageService: LocalstorageService, 
    private userRequestService: UserInfoService,
    private userStateService: LoggedUserService,
    private router: Router
    ) {
  }

  loadUser() {
    return this.userRequestService.loadUser();
  }

  logOut() {
    this.userStateService.removeUser();
    this.localStorageService.removeLocalStorageItem(Config.lsTokenKey);
    this.router.navigate(['login']);
  }

  isUserLogged() {
    return (this.localStorageService.getLocalStorageItem(Config.lsTokenKey)) ? true : false;
  }
}
